import CitizenConfig from '../config';
import axios from 'axios';

export const REQUEST_CAROUSEL = 'REQUEST_CAROUSEL';
export const RECEIVE_CAROUSEL = 'RECEIVE_CAROUSEL';

const API_CAROUSEL_URL_BACKUP = `${  CitizenConfig.API_URL}/wp/v2/carousel`;
const API_CAROUSEL_URL = '/api/carousel';

function requestCarousel(json) {
  return {
    type: REQUEST_CAROUSEL
  };
}

function receiveCarousel(json) {
  return {
    type: RECEIVE_CAROUSEL,
    items: json.data,
    receivedAt: Date.now()
  };
}

export function fetchCarousel() {
  return (dispatch) => {
    dispatch(requestCarousel());

    return axios.get(API_CAROUSEL_URL)
      .then(res => {
        dispatch(receiveCarousel(res));
      })
      .catch(err => {
        // try one more time with the fallback before giving up.
        // #cacheFallbacks
        console.warn(`Warning cache api is down: Using fallback url: ${API_CAROUSEL_URL_BACKUP}`);

        axios.get(API_CAROUSEL_URL_BACKUP)
          .then(res => {
            dispatch(receiveCarousel(res));
          })
      });
  }
}


// WEBPACK FOOTER //
// ./src/actions/CarouselActions.js